import { api, toPaginated, cleanParams } from "../lib/axios";
import type { ApiEnvelope, ListParams, PaginatedResult } from "../types/api";
import type { Transaction } from "../types/domain";

export interface TransactionListParams extends ListParams {
  status?: string;
  transactionType?: string;
  category?: string;
  paymentMode?: string;
}

export const transactionsApi = {
  async list(
    params: TransactionListParams,
  ): Promise<PaginatedResult<Transaction>> {
    const res = await api.get<ApiEnvelope<unknown>>("/admin/transactions", {
      params: cleanParams(params),
    });
    return toPaginated<Transaction>(res, "transactions");
  },

  async create(body: Record<string, unknown>): Promise<void> {
    await api.post("/admin/transactions/create", body);
  },

  async verifyDebt(body: Record<string, unknown>): Promise<Record<string, unknown>> {
    const res = await api.post<ApiEnvelope<Record<string, unknown>>>(
      "/admin/transactions/verify-debt",
      body,
    );
    return res.data.data ?? {};
  },
};
